import { Box } from '@mui/material';
import MediaEntetiesTable from '../../../common/MediaEntitiesTable';

const InstagramTable = () => {
	return (
		<Box className="w-full">
			<MediaEntetiesTable media_id={2} />
		</Box>
	);
};

export default InstagramTable;
